import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { BaseService } from './base/base.service';
import { ErrorHandlerService } from './error-handler.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class JerseySizeService extends BaseService {

  private env = environment;

  constructor(http: HttpClient, errorHandlerService: ErrorHandlerService) {
    super(http, errorHandlerService);
  }

  canAddJerseySize(memberId: string): Observable<boolean> {
    return this.http.get<boolean>(
      `${this.env.socioApiUrl}/jersey-size/can-add-jersey-size/${memberId}`
    );
  }

  getAllJerseySizes(): Observable<any[]> {
    return this.get<any[]>(`${this.env.socioApiUrl}/jersey-size/select-check-box`);
  }
}
